// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type { ConditionRules } from '../models/index';
import { ConditionRulesFromJSON, ConditionRulesToJSON } from '../models/index';

/**
 *
 */
export class ConditionsApi extends runtime.BaseAPI {
  /**
   * The conditions IMS derives from others, per entity kind and in evaluation order (ADR-0028). A derived type is True when every condition in all_of is True, and False otherwise; callers cannot write it. Types not listed here are written by callers. Static per build, so clients may cache it.
   * List derived condition rules
   */
  async v1ConditionRulesGetRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ConditionRules>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/condition-rules`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ConditionRulesFromJSON(jsonValue),
    );
  }

  /**
   * The conditions IMS derives from others, per entity kind and in evaluation order (ADR-0028). A derived type is True when every condition in all_of is True, and False otherwise; callers cannot write it. Types not listed here are written by callers. Static per build, so clients may cache it.
   * List derived condition rules
   */
  async v1ConditionRulesGet(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ConditionRules> {
    const response = await this.v1ConditionRulesGetRaw(initOverrides);
    return await response.value();
  }
}
